'use strict';

var ReviewSponsorFlightPanelDirective = function ReviewSponsorFlightPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/review-sponsor-flight-panel.html'),
    controller: 'ReviewSponsorFlightPanelController',
    link: function link() {}
  };
};
ReviewSponsorFlightPanelDirective.$inject = [];
module.exports = ReviewSponsorFlightPanelDirective;